import React from 'react';
import ENUMS from '../../enums';
import { connect } from 'react-redux';
import { formatter, enumHelper } from '../../utils';
import * as menuItemsActions from '../../redux/menuItems/actions';
import Pagination2 from '../../components/Pagination2';
import Spin from '../../components/loading';

class MenuItemsDeleteds extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      itemsPerPage: 10
    };
  }

  componentDidMount() {
    this.props.fetchAllDeletedMenuItems(
      `pageNumber=${this.state.currentPage}&pageSize=${this.state.itemsPerPage}`
    );
  }

  buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&${this.state.query || 'sort=createdAt-desc'}`;
      return query;
    }
  };

  onPageChanged = data => {
    const { currentPage, totalPages, pageLimit } = data;
    this.setState({ currentPage: currentPage }, () => {
      const query = this.buildSearchQuery(this.state.currentPage, this.state.itemsPerPage);
      this.props.fetchAllDeletedMenuItems(query);
    });
  };

  render() {
    let { deletedMenuItemsList = [], loading, error, message, failed } = this.props;
    let { totalRecords } = this.props.deletedMenuItems;
    let { currentPage, itemsPerPage } = this.state;
    return (
      <>
        <div className="col-12 d-flex justify-content-between align-items-center">
          <h3 className="text-right text-muted py-4">{locales('titles.menuItemsDeletes')}</h3>
          <div>
            <button
              onClick={() => this.props.history.push('/menu-items')}
              className="btn btn-default w-5 mx-1"
            >
              <i className="fa fa-reply" />
              {locales('labels.cancel')}
            </button>
          </div>
        </div>

        <main className="panel panel-default">
          <div className="panel-heading">
            <i className="fas fa-list-alt px-1" />
            {locales('titles.menuItemsDeletedsList')}
          </div>
          <div className="panel-body">
            <Spin spinning={loading}>
              {error && <div className="alert alert-danger">{locales('messages.server.error')}</div>}
              {failed && <div className="alert alert-danger">{message}</div>}
              <table className="table table-hover table-light table-striped">
                <thead>
                  <tr>
                    <th className="text-center">{locales('tables.row')}</th>
                    <th className="text-center ">{locales('tables.title')}</th>
                    <th className="text-center ">{locales('tables.menuCategoryTitle')}</th>
                    <th className="text-center ">
                      {locales('tables.price')}(
                      {`${
                        deletedMenuItemsList.length
                          ? enumHelper.convertEnumValueToTitle(
                              ENUMS.MONEY_UNITS.list,
                              deletedMenuItemsList[0].currency
                            )
                          : ENUMS.MONEY_UNITS.list[0].title
                      }`}
                      )
                    </th>
                    <th className="text-center ">{locales('tables.displayOrder')}</th>
                    <th className="text-center">{locales('tables.activated')}</th>
                    <th className="text-center">{locales('tables.deleter')}</th>
                    <th className="text-center">{locales('tables.deletationDate')}</th>
                  </tr>
                </thead>
                <tbody>
                  {deletedMenuItemsList.length ? (
                    deletedMenuItemsList.map((menuItem, index) => (
                      <tr key={menuItem.id}>
                        <td className="text-center">{(currentPage - 1) * itemsPerPage + index + 1}</td>
                        <td className="text-center">{menuItem.title}</td>
                        <td className="text-center">{menuItem.menuCategoryTitle}</td>
                        <td className="text-center">{formatter.numberWithCommas(menuItem.price)}</td>
                        <td className="text-center">{menuItem.displayOrder || '---'}</td>
                        <td className="text-center">
                          <i
                            className={`${
                              menuItem.isActive
                                ? 'fal fa-check-square text-success'
                                : 'fal fa-times-square text-danger'
                            }`}
                          />
                        </td>
                        <td className="text-center">{menuItem.deletedFullName}</td>
                        <td className="text-center">{menuItem.deletedAt}</td>
                      </tr>
                    ))
                  ) : (
                    <tr className="col-12 text-center">
                      <td className="alert alert-info" colSpan={12}>
                        {locales('alerts.noRecord')}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </Spin>
          </div>
        </main>
        <footer className="col-12 d-flex justify-content-center py-2">
          <div className="pagination-container">
            <Pagination2
              totalRecords={totalRecords || 0}
              pageLimit={itemsPerPage}
              pageNeighbours={2}
              onPageChanged={this.onPageChanged}
              currentPage={currentPage}
            />
          </div>
        </footer>
      </>
    );
  }
}
const mapStateToProps = state => {
  return {
    deletedMenuItemsList: state.menuItemsReducer.deletedMenuItemsList,
    loading: state.menuItemsReducer.deletedMenuItemsLoading,
    message: state.menuItemsReducer.deletedMenuItemsMessage,
    failed: state.menuItemsReducer.deletedMenuItemsFailed,
    error: state.menuItemsReducer.deletedMenuItemsError,
    deletedMenuItems: state.menuItemsReducer.deletedMenuItems
  };
};
const mapDispatchToProps = dispatch => {
  return {
    fetchAllDeletedMenuItems: query => dispatch(menuItemsActions.fetchAllDeletedMenuItems(query))
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MenuItemsDeleteds);
